import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "var(--color-green-19)",
      "fill-rule": "evenodd",
      d: "M1.552 10a8.448 8.448 0 1 1 16.896 0 8.448 8.448 0 0 1-16.896 0M10 .052C4.506.052.052 4.506.052 10S4.506 19.948 10 19.948s9.948-4.454 9.948-9.948S15.494.052 10 .052m3.514 8.581a.75.75 0 1 0-1.061-1.06l-3.264 3.263-1.642-1.642a.75.75 0 1 0-1.06 1.06l2.172 2.173a.75.75 0 0 0 1.06 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }